let socket;
let isConnected = false;
let deviceId = null;

let reconnectAttempts = 0;
let maxReconnectAttempts = Infinity; // Unlimited attempts
let reconnectDelay = 1000; // Start with 1 second
let maxReconnectDelay = 10000; // Max 10 seconds
let reconnectTimeout = null;
let heartbeatInterval = null;
let missedHeartbeats = 0;
let maxMissedHeartbeats = 3;

const hostname = window.location.hostname;

function connectWebSocket() {
  // Check if there's already a global WebSocket connection
  if (
    window.globalSocket &&
    window.globalSocket.readyState === WebSocket.OPEN
  ) {
    socket = window.globalSocket;
    isConnected = true;
    console.log('✅ Reusing existing WebSocket connection');
    startHeartbeat();
    if (
      $('body').attr('is_verifone') !== '1' ||
      $('body').attr('is_pax') !== '1'
    ) {
      checkTerminalAvailability();
    }

    const verifoneDeviceSerialNumber =
      localStorage.getItem('temrinalUniqueId') || '';
    if (
      verifoneDeviceSerialNumber &&
      $('body').attr('is-verifone-session-started') == '1' &&
      $('body').attr('p') == 'payment_standby_mode'
    ) {
      // Send targeted "available" response
      const currDeviceId = localStorage.getItem('deviceID');
      socket.send(
        JSON.stringify({
          type: 'verifone',
          action: 'terminal_available',
          temrinalUniqueId: verifoneDeviceSerialNumber,
          senderDeviceId: currDeviceId,
        })
      );
    }
    return;
  }

  if (!isConnected && (!socket || socket.readyState === WebSocket.CLOSED)) {
    const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
    socket =
      location.protocol === 'https:'
        ? new WebSocket(`${protocol}://${hostname}/ws`)
        : new WebSocket(`${protocol}://${hostname}:9090/`);

    // Store the socket globally for reuse
    window.globalSocket = socket;
    document.globalSocket = socket;

    socket.onopen = function () {
      console.log('✅ Connected to WebSocket server');
      isConnected = true;
      reconnectAttempts = 0;
      reconnectDelay = 1000;
      startHeartbeat();

      if ($('body').attr('is_verifone') !== '1') {
        checkTerminalAvailability();
      }

      const verifoneDeviceSerialNumber =
        localStorage.getItem('temrinalUniqueId') || '';
      if (
        verifoneDeviceSerialNumber &&
        $('body').attr('is-verifone-session-started') == '1' &&
        $('body').attr('p') == 'payment_standby_mode'
      ) {
        // Send targeted "available" response
        const currDeviceId = localStorage.getItem('deviceID');
        socket.send(
          JSON.stringify({
            type: 'verifone',
            action: 'terminal_available',
            temrinalUniqueId: verifoneDeviceSerialNumber,
            senderDeviceId: currDeviceId,
          })
        );
      }
    };

    socket.onmessage = function (event) {
      missedHeartbeats = 0;

      try {
        const data = JSON.parse(event.data);
        if (data.type && data.type === 'verifone') {
          const temrinalUniqueId =
            localStorage.getItem('temrinalUniqueId') || '';
          if (temrinalUniqueId && data.temrinalUniqueId != temrinalUniqueId) {
            return;
          }

          if (
            data.action === 'start_payment' ||
            data.action === 'start_refund'
          ) {
            if (
              $('body').attr('is-verifone-session-started') == '1' &&
              $('#standby-terminal-container').length
            ) {
              if (isTerminalBusy) {
                socket.send(
                  JSON.stringify({
                    type: 'verifone',
                    action: 'terminal_busy',
                    temrinalUniqueId: data.temrinalUniqueId,
                    senderDeviceId: localStorage.getItem('deviceID'),
                  })
                );
                return;
              }
              isTerminalBusy = true;
              const paymentData = data.paymentData;

              localStorage.setItem('verifoneProcessData', JSON.stringify(data));

              passTerminalDataToWebView(paymentData);
            }
          } else if (data.action === 'print') {
            const printDocument = data.printDocument;

            if (
              !data.printOnStandalone ||
              (data.printOnStandalone &&
                $('body').attr('p') == 'payment_standby_mode')
            ) {
              passTerminalDataToWebView({
                action: 'verifone',
                data: {
                  action: 'print',
                  data: {
                    document: printDocument,
                    contentTypeString: 'HTML',
                    receiptTypeString: 'DOCUMENT',
                    deliveryMethodString: 'PRINT',
                    deliveryAddress: '',
                  },
                },
              });
            }
          } else if (data.action === 'check_availability') {
            const localDeviceId = localStorage.getItem('deviceID');
            if (
              data.senderDeviceId !== localDeviceId &&
              data.temrinalUniqueId == temrinalUniqueId &&
              $('body').attr('is-verifone-session-started') == '1' &&
              $('body').attr('p') == 'payment_standby_mode' &&
              !isTerminalBusy
            ) {
              // Send targeted "available" response
              socket.send(
                JSON.stringify({
                  type: 'verifone',
                  action: 'terminal_available',
                  temrinalUniqueId: data.temrinalUniqueId,
                  targetDeviceId: data.senderDeviceId,
                  senderDeviceId: localDeviceId,
                })
              );
            }
          } else if (data.action === 'terminal_available') {
            const terminalId = data.verifoneSerialNumber;
            const button =
              $(`.order-button[data-terminal-id="${terminalId}"]`) || [];
            const quickOrderButton = $(
              `.quick-order-button[data-terminal-id="${terminalId}"]`
            );
            const printButtons = $(
              `.print-btn[data-printer-ip="${terminalId}"]`
            );
            const terminalRetryBtn = $(
              `.retry-btn[data-terminal-id="${terminalId}"]`
            );
            const cancelLastOrderBtn = $('.delete-order-confirm-btn');

            if (cancelLastOrderBtn.length) {
              cancelLastOrderBtn.prop('disabled', false);
              $('#verifone-terminal-not-available-alert').addClass('d-none');
            }

            if (
              button.length &&
              (locationCart.products?.length > 0 ||
                locationCart.exchange_amount > 0)
            ) {
              button.prop('disabled', false);
            }

            if (
              quickOrderButton.length &&
              (locationCart.products?.length > 0 ||
                locationCart.exchange_amount > 0)
            ) {
              quickOrderButton.prop('disabled', false);
            }

            if (printButtons.length) {
              printButtons.prop('disabled', false);
            }

            if (terminalRetryBtn.length) {
              terminalRetryBtn.prop('disabled', false);
            }

            if ($('#return-order-modal').hasClass('show')) {
              $('#return_with_payment_original').prop('disabled', false);
              $('#return-order-modal input[name="return_option"]:first').prop(
                'checked',
                true
              );
            }

            $('#payment-split-button').attr('disabled', false);
          } else if (data.action === 'terminal_unavailable') {
            const terminalId = data.temrinalUniqueId;
            const button =
              $(`.order-button[data-terminal-id="${terminalId}"]`) || [];
            const quickOrderButton =
              $(`.quick-order-button[data-terminal-id="${terminalId}"]`) || [];
            const printButtons = $(
              `.print-btn[data-printer-ip="${terminalId}"]`
            );
            const terminalRetryBtn = $(
              `.retry-btn[data-terminal-id="${terminalId}"]`
            );
            const cancelLastOrderBtn = $('.delete-order-confirm-btn');

            if (button.length) {
              button.prop('disabled', true);
            }

            if (quickOrderButton.length) {
              quickOrderButton.prop('disabled', true);
            }

            if (printButtons.length) {
              printButtons.prop('disabled', true);
            }

            if (terminalRetryBtn.length) {
              terminalRetryBtn.prop('disabled', true);
            }

            if ($('#return-order-modal').hasClass('show')) {
              const returnOrderTerminalId = $('#return-order-modal').data(
                'terminal-id'
              );

              if (returnOrderTerminalId == terminalId) {
                $('#return_with_cash').prop('checked', true);
                $('#return_with_payment_original').prop('disabled', true);
              }
            }

            $('#payment-split-button').attr('disabled', true);
            if (cancelLastOrderBtn.length) {
              cancelLastOrderBtn.prop('disabled', true);
              $('#verifone-terminal-not-available-alert').removeClass('d-none');
            }
          } else if (data.action === 'user_cancelled_payment') {
            const { deviceId: targetDeviceId, temrinalUniqueId } = data;

            if (targetDeviceId !== deviceId) {
              return;
            }

            if ($('#cancel-last-order-confirm-modal').length > 0) {
              $('#cancel-last-order-confirm-modal').modal('hide');
              showToast({
                message: 'Klarte ikke å avbryte',
                type: 'error',
                position: 'bottom-center',
              });
            }

            updateOrderProcessStatus(temrinalUniqueId, 'failed');

            if ($('#payment-split-modal').hasClass('show')) {
              const splitButton = $('#payment-split-button');
              splitButton.attr('disabled', false);
              splitButton.find('div.loader').remove();
              splitButton.text(splitButton.attr('data-original-text'));

              $('#payment-split-input').attr('disabled', false);
              $('#split-methods-select').attr('disabled', false);
            }
          } else if (data.action === 'declined_payment') {
            const { deviceId: targetDeviceId, temrinalUniqueId } = data;

            if (targetDeviceId !== deviceId) {
              return;
            }

            updateOrderProcessStatus(temrinalUniqueId, 'failed');

            if ($('#payment-split-modal').hasClass('show')) {
              const splitButton = $('#payment-split-button');
              splitButton.attr('disabled', false);
              splitButton.find('div.loader').remove();
              splitButton.text(splitButton.attr('data-original-text'));

              $('#payment-split-input').attr('disabled', false);
              $('#split-methods-select').attr('disabled', false);
            }
          } else if (data.action === 'completed_payment') {
            const {
              completedInfo,
              orderProducts,
              deviceId: targetDeviceId,
              redirectUrl,
            } = data;

            if (targetDeviceId !== deviceId) {
              return;
            }
            removeOrderProcessStatus(completedInfo.temrinalUniqueId);

            setTimeout(() => {
              if ($('#externalPaymentProcessModal').hasClass('show')) {
                $('#externalPaymentProcessModal').modal('hide');
              }

              if (completedInfo.orderPaymentSplitId) {
                const splitInput = $(
                  ".payment-split-input[data-payment-method='payment_verifone_terminal'], " +
                    ".payment-split-input[data-payment-method='payment_pax_terminal']"
                );
                const splitButton = $(
                  ".order-payment-split[data-payment-method='payment_verifone_terminal'], " +
                    ".order-payment-split[data-payment-method='payment_pax_terminal']"
                );
                splitButton.find('div.loader').remove();
                splitButton.attr('disabled', false);
                splitInput.attr('disabled', false);
                $('#split-methods-select').attr('disabled', false);
                splitButton.text(splitButton.attr('data-original-text'));
                const paidAmount = parseFloat(splitInput.val());
                splitInput.val('');

                let totalAmount = parseFloat(
                  splitInput.attr('data-max-allowed')
                );
                const remainingAmout = parseFloat(
                  $('#total-amount').attr('data-total-amount')
                );

                const totalPaid = totalAmount - remainingAmout + paidAmount;
                if (totalPaid > 0) {
                  const remainingValue =
                    (totalAmount * 100 - totalPaid * 100) / 100;
                  $('#total-amount').text(
                    `Gjenværende totalt: ${formattedPriceToShow(remainingValue)}`
                  );
                  $('#total-amount').attr('data-total-amount', remainingValue);

                  $('#payment-split-input').attr(
                    'data-max-allowed',
                    remainingValue
                  );
                }
              }

              if (
                completedInfo.tableSessionId &&
                $('#table-session-details-modal.show').length > 0 &&
                $('#table-session-details-modal').attr(
                  'data-table-session-id'
                ) == completedInfo.tableSessionId &&
                $('#btnSyncState').hasClass('d-none')
              ) {
                let isShareByAmount = $('mode-tab[data-mode="sum"]').hasClass(
                  'active'
                )
                  ? 1
                  : 0;

                if (!isShareByAmount) {
                  $('#btnSyncState').removeClass('d-none').addClass('d-flex');
                }
              }

              const $confirmationStyle = $('#classic-location-products').data(
                'order-confirmation-toast-style'
              );
              if (completedInfo.posSale && completedInfo.posSale == 2) {
                showToast({
                  type: 'success',
                  message: 'Veksel vellykket',
                  duration: 2000,
                });

                $('#cash-exchange-input').val('');
              } else if (
                completedInfo.order_html &&
                completedInfo.order_html !== ''
              ) {
                $('.confirmation-toast').remove();
                $('#content').append(
                  '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                    (window.innerWidth >= 500 ? ' right: 0;' : '') +
                    ' width: 480px; display: none;">' +
                    '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
                    ($confirmationStyle == 'compact' ? 'false' : 'true') +
                    '" data-delay="' +
                    ($confirmationStyle === 'compact' ? 100000 : 3000) +
                    '">' +
                    '  <div class="toast-header">' +
                    '    <strong class="mr-auto">Ordre registrert</strong>' +
                    '    <small></small>' +
                    '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                    '      <span aria-hidden="true">&times;</span>' +
                    '    </button>' +
                    '  </div>' +
                    '  <div class="toast-body">' +
                    completedInfo.order_html +
                    '  </div>' +
                    '</div>' +
                    '</div>'
                );
              }

              if (
                completedInfo.item_count &&
                completedInfo.total_amount &&
                $confirmationStyle === 'compact'
              ) {
                showPreviousSaleBar(
                  completedInfo.item_count,
                  completedInfo.total_amount
                );

                if (locationCart.products?.length <= 0) {
                  showOrderSuccessCheckmark();
                }
              } else if (
                completedInfo.order_html &&
                completedInfo.order_html !== ''
              ) {
                $('.confirmation-toast').css({ padding: '1rem' }).show();
                $('.confirmation-toast-box')
                  .toast('show')
                  .on('hidden.bs.toast', function () {
                    $('.confirmation-toast').attr('style', function (i, s) {
                      return (s || '') + 'padding: 0px !important;';
                    });
                  });

                if (locationCart.products?.length <= 0) {
                  showOrderSuccessCheckmark();
                }
              }

              if (orderProducts && orderProducts.length > 0) {
                const productsWithCount = [];

                orderProducts.forEach((product) => {
                  const productDetail = `(${product.quantity})${product.name}`;
                  productsWithCount.push(productDetail);
                });

                localStorage.setItem(
                  'lastOrderProducts',
                  JSON.stringify(productsWithCount)
                );
                localStorage.setItem(
                  'lastOrderTotal',
                  completedInfo.total_amount
                );

                if ($('#payment-split-modal').length) {
                  $('#payment-split-modal').modal('hide');

                  removeQueryParams('order');
                  emptyAllCart('order_complete');
                  closePanel();
                }

                setLastOrderDetails();
              }

              if (redirectUrl) {
                document.location.href = redirectUrl;
              }
            }, 1000);
          } else if (data.action === 'terminal_update') {
            const { terminalId, organizerId, terminalName } = data.data;
            if (
              p === 'payment_standby_mode' &&
              terminalId == temrinalUniqueId &&
              organizerId == $('body').attr('organizer_id')
            ) {
              $('#terminalNumber').text(terminalName);
            }
          } else if (data.action === 'completed_refund') {
            const { deviceId: targetDeviceId } = data;

            if (targetDeviceId !== deviceId) {
              return;
            }

            if ($('#cancel-last-order-confirm-modal').length > 0) {
              $('#cancel-last-order-confirm-modal').modal('hide');
            }
            $('.return-order-success-section ').removeClass('d-none');
            $('.return-order-progress-section').addClass('d-none');
            popupAlert();
            setTimeout(() => {
              localStorage.removeItem('verifoneProcessData');
              localStorage.removeItem('verifone_refund_data');

              if (p == 'statistic_order') {
                getAmountOfOrderAndSale(
                  startDate,
                  endDate,
                  period,
                  supplierId,
                  productGroupUniqueId,
                  locationId,
                  userId,
                  platform,
                  customPeriod,
                  topProductGroupUniqueId,
                  customerId,
                  compareBy,
                  productId,
                  vatCode,
                  paymentMethod
                );
                $('.modal-backdrop').remove();
              } else if (p == 'today_orders') {
                $('#return-order-progress-modal').modal('hide');
                $(`tr[data-order-id="${data.returnedOrderId}"]`).fadeOut(
                  400,
                  function () {
                    $(this).remove();
                  }
                );
                $(`ul[data-order-id="${data.returnedOrderId}"]`).fadeOut(
                  400,
                  function () {
                    $(this).remove();
                  }
                );
              } else if (p == 'order_confirmation' && data.redirectUrl) {
                document.location.href = data.redirectUrl;
              }
            }, 1500);
          } else if (data.action === 'declined_refund') {
            const { deviceId: targetDeviceId } = data;
            if (targetDeviceId !== deviceId) {
              return;
            }

            let errorMessage = 'Ikke klarer å retur !';

            if ($('#cancel-last-order-confirm-modal').length > 0) {
              $('#cancel-last-order-confirm-modal').modal('hide');
              showToast({
                type: 'error',
                message: errorMessage,
                position: 'bottom-center',
                duration: 4000,
              });
            }

            $('.return-order-progress-section').addClass('d-none');
            $('.return-error-message-section').removeClass('d-none');
            $('.return-error-message-section .return-error-message').text(
              errorMessage
            );
            $('.return-order-progress-action-btn').prop('disabled', false);
            localStorage.removeItem('verifoneProcessData');
            localStorage.removeItem('verifone_refund_data');
          }
          return;
        }

        if (data.type && data.type === 'pax') {
          const temrinalUniqueId =
            localStorage.getItem('temrinalUniqueId') || '';
          if (temrinalUniqueId && data.temrinalUniqueId != temrinalUniqueId) {
            return;
          }

          if (data.action === 'print') {
            const printDocument = data.printDocument;
            const printSegments = data.printSegments || [];

            passTerminalDataToWebView({
              action: 'pax',
              data: {
                action: 'print',
                data: {
                  document: printDocument,
                  segments: printSegments,
                  contentTypeString: 'HTML',
                  receiptTypeString: 'DOCUMENT',
                  deliveryMethodString: 'PRINT',
                  deliveryAddress: '',
                },
              },
            });
          }
        }
        if (data.type === 'ping_device' && data.target_device_id === deviceId) {
          const pongData = {
            type: 'pong',
            from_device_id: deviceId,
            original_sender: data.sender_id,
          };
          socket.send(JSON.stringify(pongData));
          return;
        }

        if (
          data.type &&
          (data.type === 'created_start_balance' ||
            data.type === 'created_z_report' ||
            data.type === 'print_x_report')
        ) {
          const temrinalUniqueId =
            localStorage.getItem('temrinalUniqueId') || '';
          if (data?.zReportData) {
            if (
              (data.zReportData.type === 'VERIFONE' ||
                data.zReportData.type === 'PAX') &&
              data.zReportData.ipAddress === temrinalUniqueId
            ) {
              passTerminalDataToWebView({
                action:
                  data.zReportData.type === 'VERIFONE' ? 'verifone' : 'pax',
                data: {
                  action: 'print',
                  data: {
                    document: data.zReportData.printDocument,
                    segments: data.zReportData.printSegments,
                    contentTypeString: 'HTML',
                    receiptTypeString: 'DOCUMENT',
                    deliveryMethodString: 'PRINT',
                    deliveryAddress: '',
                  },
                },
              });
            }

            if (data.zReportData.main_pos_device_id === deviceId) {
              passDataToWebView(
                event,
                data.type === 'print_x_report'
                  ? 'print_x_report'
                  : 'print_z_report',
                data.zReportData.printData,
                data.zReportData.ipAddress,
                data.zReportData.type
              );
            }
          }

          const locationIdFromStorage = localStorage.getItem(
            data.organizer_id + '_mainLocationId'
          );
          if (locationIdFromStorage == data.location_id) {
            $.ajax({
              url: '/api/v1/check-login',
              method: 'GET',
              dataType: 'json',
            })
              .done(function (responseData) {
                if (
                  responseData &&
                  responseData.isLoggedIn &&
                  responseData.mainLocationId == data.location_id
                ) {
                  if ($('body').attr('p') === 'starting_cash_balance') {
                    window.location.reload();
                    return;
                  }

                  if (
                    responseData.redirect_url &&
                    $('body').attr('p') !== 'payment_standby_mode' &&
                    responseData.mainLocationId == data.location_id
                  ) {
                    window.location.href = responseData.redirect_url;
                  }
                }
              })
              .fail(function (xhr) {
                if (
                  xhr.responseJSON &&
                  xhr.responseJSON.redirect_url !== undefined &&
                  xhr.responseJSON.redirect_url !== null
                ) {
                  document.location.href = xhr.responseJSON.redirect_url;
                }
              });
          }
          return;
        }

        if (
          data.type &&
          data.type === 'web_print_order' &&
          data.main_pos_device_id === deviceId
        ) {
          passDataToWebView(
            event,
            'web_print_order',
            data.order_data,
            null,
            null,
            null,
            null,
            data.requested_device_id
          );
          return;
        }

        if (
          data.type &&
          data.type === 'advance_receipt' &&
          data.main_pos_device_id === deviceId
        ) {
          passDataToWebView(
            event,
            'advance_receipt',
            data.orderProducts,
            data.ipAddress,
            data.printerType,
            data.organizer,
            null,
            data.requested_device_id,
            data.tableNumber,
            data.tableCustomerName
          );
          return;
        }

        if (
          data.type &&
          data.type === 'open_drawer' &&
          data.main_pos_device_id === deviceId
        ) {
          window.ReactNativeWebView.postMessage(JSON.stringify(data.message));
        }

        if (
          data.type &&
          data.type === 'print_pull_data' &&
          data.main_pos_device_id === deviceId
        ) {
          const { orderData } = data;
          passDataToWebView(event, 'print_poll_order', orderData);
        }

        if (
          data.type &&
          data.type === 'supply_list' &&
          data.main_pos_device_id === deviceId
        ) {
          passDataToWebView(
            event,
            'supply_list',
            data.orderProducts,
            data.ipAddress,
            data.printerType,
            data.organizer,
            null,
            data.requested_device_id,
            data.tableNumber,
            data.tableCustomerName,
            data.date
          );
          return;
        }

        if (
          data.type &&
          data.type === 'main-device-print-service' &&
          data.main_pos_device_id === deviceId &&
          data.printData
        ) {
          window.ReactNativeWebView.postMessage(JSON.stringify(data.printData));
        }

        if (data.type && data.type === 'update_dinein_cart') {
          const shopType = $('body').attr('shop_type');
          const productsList = data.products;
          if (shopType === 'dine-in' && $('#cart-modal').hasClass('show')) {
            if (productsList.length > 0 && getCartModal) {
              locationCart.products = productsList;
              getCartModal();
            }
          }
          return;
        }

        // If the order is complete and matches this screen
        if (
          data.type &&
          (data.type === 'order_complete' || data.type === 'order_cancelled') &&
          data.deviceId
        ) {
          resetCustomerScreen(data, data.type);
          return;
        }

        updateCustomerScreen(data);
      } catch (e) {
        console.error('❌ Invalid JSON from server:', e);
      }
    };

    socket.onclose = function () {
      console.warn('⚠️ WebSocket closed');
      isConnected = false;
      window.globalSocket = null;
      stopHeartbeat();
      scheduleReconnect();
    };

    socket.onerror = function (error) {
      console.error('❌ WebSocket error:', error);
    };
  }
}

$(document).on('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    if (!socket || socket.readyState !== WebSocket.OPEN) {
      forceReconnect();
    } else {
      try {
        socket.send(JSON.stringify({ type: 'heartbeat' }));
      } catch (e) {
        forceReconnect();
      }
    }
  }
});

window.addEventListener('online', () => {
  if (!socket || socket.readyState !== WebSocket.OPEN) {
    forceReconnect();
  }
});

window.addEventListener('offline', () => {
  if (socket) {
    socket.close();
  }
});

function scheduleReconnect() {
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
  }

  if (reconnectAttempts < maxReconnectAttempts) {
    reconnectAttempts++;
    const delay = Math.min(
      reconnectDelay * Math.pow(1.5, reconnectAttempts - 1),
      maxReconnectDelay
    );
    console.log(
      `🔄 Attempting to reconnect in ${delay / 1000} seconds... (Attempt ${reconnectAttempts})`
    );
    reconnectTimeout = setTimeout(() => {
      console.log('🔄 Reconnecting WebSocket...');
      connectWebSocket();
    }, delay);
  } else {
    console.error('❌ Max reconnection attempts reached');
  }
}

function startHeartbeat() {
  stopHeartbeat();

  heartbeatInterval = setInterval(() => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      missedHeartbeats++;

      if (missedHeartbeats >= maxMissedHeartbeats) {
        console.warn('⚠️ Connection appears dead, closing socket');
        forceReconnect();
        return;
      }

      try {
        socket.send(JSON.stringify({ type: 'heartbeat' }));
      } catch (e) {
        forceReconnect();
      }
    }
  }, 10000); // 10 seconds
}

function stopHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
  missedHeartbeats = 0;
}

function forceReconnect() {
  if (socket) {
    socket.close();
  }
  reconnectAttempts = 0;
  connectWebSocket();
}

function isWebSocketConnected() {
  return socket && socket.readyState === WebSocket.OPEN && isConnected;
}

function updateCustomerScreen(data) {
  const POSDeviceId = data.deviceId;
  const connectedDeviceId = $('body').attr('deviceId');

  if (POSDeviceId !== connectedDeviceId) {
    return;
  }

  if ($('.customer-screen-view-container').hasClass('mobile')) {
    $('.carousel-contanier').addClass('d-none');
    $('.checkout-screen-container ').removeClass('d-none');
    $('.checkout-screen-container ').addClass('w-100');
  } else {
    if ($('.carousel-contanier').hasClass('w-100')) {
      $('.carousel-contanier').removeClass('w-100');
      $('.carousel-contanier').addClass('w-50');
      $('.carousel-contanier').css('padding-right', '16px');
    }
    if ($('.checkout-screen-container ').hasClass('d-none')) {
      $('.checkout-screen-container ').removeClass('d-none');
      $('.checkout-screen-container ').addClass('w-50');
    }
  }
  const $checkout = $('.customer-screen-checkout');
  $checkout.empty();

  if (data.share_by_amount && data.share_by_amount.length > 0) {
    const shareByAmountOrder = data.share_by_amount[0];
    const tableName = decodeHtml(shareByAmountOrder.table_name);
    const personName = decodeHtml(shareByAmountOrder.person_name);
    const amount = formattedPriceToShow(shareByAmountOrder.amount);

    const amountCard = `
      <div class="amount-card">
        <div class="ac-label">
          Betalende person: <span class="ac-name">${personName}</span>
        </div>
        <div class="ac-label">
          Bordnummer: <span class="ac-name">${tableName}</span>
        </div>
        <div class="ac-amount">
          ${amount}<span class="ac-currency">kr</span>
        </div>
      </div>`;
    $checkout.append(amountCard);

    $('.customer-screen-summary').addClass('d-none');
  } else if (data.exchange_amount && data.exchange_amount > 0) {
    const exchangeAmount = formattedPriceToShow(data.exchange_amount);

    const exchangeAmountCard = `
      <div class="amount-card">
        <div class="ac-label">
          Vekslebeløp: <span class="ac-amount">${exchangeAmount}<span class="ac-currency">kr</span></span>
        </div>
      </div>`;
    $checkout.append(exchangeAmountCard);

    $('.customer-screen-summary').addClass('d-none');
  } else if (Array.isArray(data.products)) {
    $.each(data.products, function (index, product) {
      const productPrice =
        parseFloat(product.price) *
        (1 - parseFloat(product.discount_percent) / 100);

      const mainDiv = $('<div>').addClass('product-detail');
      const productDetailsDiv = $('<div>')
        .addClass('product-name')
        .text(
          `${formattedPriceToShow(product.quantity)} x ${decodeHtml(product.name)}${
            parseFloat(product.discount_percent) > 0
              ? ` (${product.discount_percent}%)`
              : ''
          }`
        );

      // Add product extras if they exist
      if (product.product_extra) {
        $.each(product.product_extra, function (i, extra) {
          const extraDiv = $('<div>').addClass('extra-item w-100 pl-4');
          const extraDetailsDiv = $('<div>')
            .addClass('product-name')
            .text(`- ${decodeHtml(extra.extra_name)} x ${extra.amount}`);

          extraDiv.append(extraDetailsDiv);
          productDetailsDiv.append(extraDiv);
        });
      }
      const priceDiv = $('<div>')
        .addClass('product-price')
        .text(`${formattedPriceToShow(productPrice)} kr`);

      mainDiv.append(productDetailsDiv).append(priceDiv);

      $checkout.append(mainDiv);
    });

    const totalPrice = parseFloat(data.total);
    const totalDiscountPrice = parseFloat(data.total_with_discount);

    if ($('.customer-screen-summary').hasClass('d-none')) {
      $('.customer-screen-summary').removeClass('d-none');
    }
    $('#discount-percent').text(
      ` ${formattedPriceToShow(data.discount_percent)} %`
    );
    $('#total-price').text(` ${formattedPriceToShow(totalPrice)} kr`);
    $('#total-discount-price').text(
      ` ${formattedPriceToShow(totalDiscountPrice)} kr`
    );
  }
}

function resetCustomerScreen(data, type) {
  const POSDeviceId = data.deviceId;
  const connectedDeviceId = $('body').attr('deviceId');

  if (POSDeviceId != connectedDeviceId) {
    return;
  }

  if (type === 'order_complete') {
    $('.customer-screen-checkout')
      .empty()
      .append(
        '<div class="confirmation-toast w-100">' +
          '<div class="d-flex flex-column justify-content-center align-items-center w-100">' +
          '<div id="success-icon" class="rounded-full text-success"><i class="material-icons">check_circle_outline</i></div>' +
          '<div>Takk for handelen!</div>' +
          '</div>' +
          '</div>'
      );

    setTimeout(() => {
      if ($('.customer-screen-view-container').hasClass('mobile')) {
        $('.carousel-contanier').removeClass('d-none').addClass('w-100');
        $('.checkout-screen-container').removeClass('w-100').addClass('d-none');
        $('.carousel-contanier').css('padding-right', '0');
      } else {
        $('.confirmation-toast').remove();
        $('.customer-screen-checkout').empty();
        $('#total-price').text('');
        $('.carousel-contanier').removeClass('w-50').addClass('w-100');
        $('.carousel-contanier').css('padding-right', '0');
        $('.checkout-screen-container').removeClass('w-50').addClass('d-none');
      }
    }, 3000);
  } else if (type === 'order_cancelled') {
    $('.customer-screen-checkout').empty();
    if ($('.customer-screen-view-container').hasClass('mobile')) {
      $('.carousel-contanier').removeClass('d-none').addClass('w-100');
      $('.checkout-screen-container').removeClass('w-100').addClass('d-none');
      $('.carousel-contanier').css('padding-right', '0');
    } else {
      $('.confirmation-toast').remove();
      $('.customer-screen-checkout').empty();
      $('#total-price').text('');
      $('.carousel-contanier').removeClass('w-50').addClass('w-100');
      $('.carousel-contanier').css('padding-right', '0');
      $('.checkout-screen-container').removeClass('w-50').addClass('d-none');
    }
  }
}

function sendUpdateToServer(data) {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(data));
  } else {
    console.warn('⚠️ Cannot send, WebSocket not connected');
  }
}

$(document).ready(function () {
  let p = $('body').attr('p');
  deviceId = $('body').attr('device_id');
  let locationId = $('body').attr('location_id');

  if (
    !(p == 'customer_screen' || p == 'events' || p == 'payment_standby_mode')
  ) {
    if ((socket && socket.readyState === WebSocket.OPEN) || isConnected) {
      socket.close();
    }
  }

  if (p == 'customer_screen') {
    connectWebSocket();
    $('header').hide();

    $(document).on('submit', '#device-id-form', function (e) {
      e.preventDefault();
      const POSDeviceId = $('#pos-device-id').val();
      const locationId = $('#location-id').val();
      const disabledOnClick = $('#to-customer-screen');
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/customer-screen/check-device-id',
        data: {
          location_id: locationId,
          device_id: POSDeviceId,
        },
      })
        .done(function (data) {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Bekreft');
          if (data.success) {
            const customerScreenUrl =
              window.location.pathname + '?deviceId=' + POSDeviceId;
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: 'save_customer_screen_url',
                  data: customerScreenUrl,
                })
              );
            }
            window.location.href = customerScreenUrl;
          } else {
            alert(data.message);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Bekreft');
          alert('Failed to set device ID.');
          return;
        });
    });

    let tapCount = 0;
    let tapTimer = null;
    let lastTouchTime = 0;
    const MAX_DELAY = 800; // ms allowed between taps
    const TOUCH_CLICK_GAP = 500; // ms window to ignore synthetic click after touch

    function registerTap() {
      tapCount++;

      clearTimeout(tapTimer);
      tapTimer = setTimeout(function () {
        tapCount = 0;
      }, MAX_DELAY);

      if (tapCount === 5) {
        clearTimeout(tapTimer);
        tapCount = 0;

        console.log('5 continuous taps/clicks detected!');
        $('#exit-customer-screen-modal').modal('show');
      }
    }

    $(document).on('touchstart', function () {
      lastTouchTime = Date.now();
      registerTap();
    });

    $(document).on('click', function () {
      if (Date.now() - lastTouchTime < TOUCH_CLICK_GAP) {
        return;
      }
      registerTap();
    });

    $(document).on('click', '#confirm-exit-customer-screen-btn', function () {
      $('#exit-customer-screen-modal').modal('hide');
      const dashboardUrl = $('.navbar-brand').attr('data-single-tap-href');

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: 'remove_customer_screen_url',
          })
        );
      }

      window.location.href = dashboardUrl;
    });
  }
});
